import { useStaticQuery, graphql } from "gatsby";

export const useLatestNews = ({ filterId }) => {
  const { allMarkdownRemark } = useStaticQuery(
    graphql`
      query LatestNewsTemplate {
        allMarkdownRemark(sort: { frontmatter: { date: DESC } }, limit: 10) {
          nodes {
            ...TextArticle
          }
        }
      }
    `
  );
  return allMarkdownRemark.nodes.filter(({ id }) => id !== filterId);
};
